import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
    selector: 'app-404',
    templateUrl: './pagenotfound.component.html',
    styleUrls: ['./pagenotfound.component.scss']
})

export class PageNotFoundComponent implements OnInit {
    constructor() {

    }

    ngOnInit(){
        window.scroll(0,0);
    }
}